/* istanbul ignore file */
import { optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { ClearPasswordData } from './ClearPasswordData';
import { ClearSessionLockdownData } from './ClearSessionLockdownData';
import { SetPasswordData } from './SetPasswordData';
import { SetSessionLockdownData } from './SetSessionLockdownData';
const PatchRestrictionDataParser = 
/* #__PURE__ */ parsers.object([
    [
        'password',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['set', SetPasswordData],
            ['not-set', ClearPasswordData],
        ])),
    ],
    [
        'sessionLockdown',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['set', SetSessionLockdownData],
            ['not-set', ClearSessionLockdownData],
        ])),
        'session_lockdown',
    ],
]);
export class PatchRestrictionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchRestrictionDataParser.decode(input).map(res => new PatchRestrictionData(res));
    }
    static unsafeDecode(input) {
        return PatchRestrictionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchRestrictionDataParser.encode(data);
    }
    static schema() {
        return PatchRestrictionDataParser.schema();
    }
}
